import { Component, Input } from '@angular/core';
import { UpsellFaqItem } from 'src/app/models/upsellFaqItem';

@Component({
  selector: 'upsell-faq',
  templateUrl: 'upsell-faq.html',
  styleUrls: ["upsell-faq.scss"],
})
export class UpsellFaqsComponent {
  @Input() upsellFaqTitle = 'Frequently Asked Questions';
  @Input() upsellFaqContent: UpsellFaqItem[] = [];

  trackByFn(index: number, item: UpsellFaqItem): string | number {
    return item?.id || index;
  }
}
